import HideOnNative from '@/common/HideOnNative';
import Filters from '@/srp/MainLayout/Filters';
import SearchBar from '@/srp/MainLayout/SearchBar';
import Modals from '@/srp/Modals';
import Breadcrumbs from '@/srp/SEOSection/BreadCrumbs';
import { useIsDesktop, useIsMobile } from '~/context/common/DeviceContext';
import { useConfiguration } from '~/context/common/StaticContext';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import {
  useFreeTextNoResults,
  useHasInventoryError
} from '~/context/srp/InventoryContext';
import useIsInSuggestedFilters2RowExperiment from '~/hooks/srp/useIsInSuggestedFilters2RowExperiment';
import NativeError from '~/native/srp/NativeError';
import type { SeoProps } from '~/server-props/srp/contracts';
import DeliveryUnavailableBanner from './DeliveryUnavailableBanner';
import HeaderOverlay from './HeaderOverlay';
import { Container, FiltersResultsContainer, Main } from './MainLayout.styles';
import QuickFilters from './QuickFilters';
import QuickMenu from './QuickMenu';
import SearchTools from './SearchTools';
import Banner from '../Banners/Banner';
import { ResultsSection } from '../ResultsSection';
import ContentResultsResearch from '../SEOSection';
import ShowConditionally from '../ShowConditionally';

function useDisableSeo() {
  const { disableSeoLinks } = useConfiguration();

  return disableSeoLinks;
}

type OwnProps = {
  initialSeoProps?: SeoProps;
};

export default function MainLayout({ initialSeoProps }: OwnProps) {
  const disableSeo = useDisableSeo();
  const freeTextNoResults = useFreeTextNoResults();
  const hasInventoryError = useHasInventoryError();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();
  const show2RowSuggestedFilters = useIsInSuggestedFilters2RowExperiment();
  const showComposerTreatment = useShowComposerTreatment();

  return (
    <div className="relative m-auto max-w-[1800px]">
      <ShowConditionally dealership={false}>
        <HeaderOverlay />
      </ShowConditionally>
      <NativeError />
      <DeliveryUnavailableBanner />
      <Container>
        <FiltersResultsContainer>
          <Filters />
          {!isDesktop && !showComposerTreatment && <SearchBar />}
          <Main id="srp-main-content">
            {isDesktop && !showComposerTreatment && <SearchBar />}
            <ShowConditionally dealership={false}>
              {isMobile &&
                !showComposerTreatment &&
                !show2RowSuggestedFilters && <QuickMenu />}

              {!freeTextNoResults && !showComposerTreatment && <QuickFilters />}

              {!freeTextNoResults && <SearchTools />}
            </ShowConditionally>

            <div className="relative z-0 min-w-0 sm:p-0">
              {!freeTextNoResults &&
                !hasInventoryError &&
                !showComposerTreatment && <Banner />}
              <ResultsSection />
            </div>
          </Main>
        </FiltersResultsContainer>
      </Container>
      <HideOnNative>
        <Breadcrumbs />
      </HideOnNative>
      <Modals />
      <HideOnNative>
        <ShowConditionally dealership={false}>
          {disableSeo ? null : (
            <ContentResultsResearch initialSeoProps={initialSeoProps} />
          )}
        </ShowConditionally>
      </HideOnNative>
    </div>
  );
}
